import api from '../config/api';

import { formatErrorResponse } from '../utils/response';
import { makeSearchParams } from '../utils/params';

export async function loadCountries() {
  const response = await api.get('/countries');
  if (response.ok) {
    return { ok: true, list: response.data };
  }
  return formatErrorResponse(response);
}

export async function loadLastProducts(page = 1, options = {}) {
  const { params, ...extra } = makeSearchParams(page, options);
  const response = await api.get('/products', {}, { params });
  if (response.ok) {
    return {
      page,
      ...extra,
      ok: true,
      list: response.data.page,
      totalPages: response.data.total_pages,
      total: response.data.total_count,
    };
  }
  return formatErrorResponse(response);
}

export async function loadCategories() {
  const response = await api.get('/categories');
  if (response.ok) {
    return { ok: true, list: response.data };
  }
  return formatErrorResponse(response);
}

export async function loadCollections() {
  const response = await api.get('/collections');
  if (response.ok) {
    return { ok: true, list: response.data };
  }
  return formatErrorResponse(response);
}

export async function loadFullCollections(page = 1, options = {}) {
  const { params, ...extra } = makeSearchParams(page, options);
  const response = await api.get('/collections/latests', {}, { params });
  if (response.ok) {
    return {
      page,
      ...extra,
      ok: true,
      list: response.data.page,
      totalPages: response.data.total_pages,
      total: response.data.total_count,
    };
  }
  return formatErrorResponse(response);
}

export async function loadLocales() {
  const response = await api.get('/locales');
  if (response.ok) {
    return { ok: true, list: response.data };
  }
  return formatErrorResponse(response);
}

export async function loadVendors(page = 1, options = {}) {
  const { params, ...extra } = makeSearchParams(page, options);
  const response = await api.get('/vendors', {}, { params });
  if (response.ok) {
    return {
      page,
      ...extra,
      ok: true,
      vendors: response.data.page,
      totalPages: response.data.total_pages,
      total: response.data.total_count,
    };
  }
  return formatErrorResponse(response);
}

export async function loadVendorDetails(id) {
  const response = await api.get(`/vendors/${id}`);
  if (response.ok) {
    return {
      ok: true,
      vendor: response.data,
    };
  }
  return formatErrorResponse(response);
}

export async function loadVendorProducts(id, page = 1, options = {}) {
  const { params, ...extra } = makeSearchParams(page, options);
  const response = await api.get(`/vendors/${id}/products`, {}, { params });
  if (response.ok) {
    return {
      page,
      ...extra,
      ok: true,
      products: response.data.page,
      totalPages: response.data.total_pages,
      total: response.data.total_count,
      vendor: response.data,
    };
  }
  return formatErrorResponse(response);
}

export async function enableUser(id, userType) {
  const response = await api.patch(`/${userType}/${id}/enable`);
  if (response.ok) {
    return {
      ok: true,
    };
  }
  return formatErrorResponse(response);
}

export async function disableUser(id, userType) {
  const response = await api.patch(`/${userType}/${id}/disable`);
  if (response.ok) {
    return {
      ok: true,
    };
  }
  return formatErrorResponse(response);
}



// WEBPACK FOOTER //
// ./src/services/DatabaseService.js